import { Stack, Typography } from '@mui/material';
import { FirstSection, SecondSection } from '../components';
import { FormProvider } from 'react-hook-form';
import { useDashboardForm } from '../hooks';

export const Dashboard = () => {
  const form = useDashboardForm();

  return (
    <FormProvider {...form}>
      <Stack>
        <FirstSection />
        <SecondSection />
      </Stack>
    </FormProvider>
  );
};
